<template>
  <div class="page-history">
    <div>first: <a href="">{{ history.first }}</a> prev: <a href="">{{ history.prev }}</a> next: <a href="">{{ history.next }}</a> last: <a href="">{{ history.last }}</a></div>
    <div>
      <BookmarkDate :creationDate="history.creationdate"></BookmarkDate>
      <LinkCount
            class="bookmark-uri"
            :bookmarkId="id"
            :link="history.uri">
            {{ history.uri }}
          </LinkCount>
    </div>
    <Description :description="history.content"></Description>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'
import BookmarkDate from '@/components/common/BookmarkDate'
import Description from '@/components/bookmark/Description'
import LinkCount from '@/components/bookmark/LinkCount'

@Component({
  name: 'PageHistory',
  props: [
    'id',
    'date'
  ],
  components: {
    BookmarkDate,
    Description,
    LinkCount
  }
})
class PageHistory extends Vue {
  @Prop id
  @Prop date

  history = {}

  fetchHistory() {
    let searchParams = new URLSearchParams()
    this.date && searchParams.append('date', this.date)
    this.$fetch.get(`/bookmarks/${this.id}/history?${searchParams.toString()}`).then(
      data => {
        this.history = data
      },
      err => {
        console.log("Can't fetch history", err)
      }
    )
  }


  beforeMount() {
    console.log('beforeMounted page history')
    this.fetchHistory()
  }
}

export default PageHistory
</script>

<style lang="less" scoped>
</style>